/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: 'tableCommon.sl_no',
        accessor: 'slno',
      },
      {
        Header: 'applicationConfiguration.tableColumns.gradeType',
        accessor: 'grade',
      },
      {
        Header: 'scheduleFrequency.tableColumns.activity_type_name',
        accessor: 'activity_type',
      },
      {
        Header: 'applicationConfiguration.tableColumns.minCFUCount',
        accessor: 'min_count',
      },
      {
        Header: 'applicationConfiguration.tableColumns.maxCFUCount',    
        accessor: 'max_count',
      },
]

interface TableColumn {
    Header: string;
    accessor: string;
  }